module.exports = __webpack_public_path__ + "static/media/bg12.825513f5.jpg";